module.exports = __webpack_public_path__ + "static/merregon-159e3de21967096f30607a58ae322626.png";